import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button} from 'reactstrap'
import {Query} from 'react-apollo'
import classnames from 'classnames';
import {ToastContainer} from 'react-toastify'
import {
    Redirect
} from "react-router-dom"
import 'react-toastify/dist/ReactToastify.css';

import ProjectSummaryBar from './ProjectSummaryBar'
import ProjectForm from './ProjectForm'
import ProjectLocation from './ProjectLocation'
import ProjectLocationsList from './ProjectLocationsList'
import ProjectNotesList from "./ProjectNotesList";
import ProjectNoteCreate from "./ProjectNoteCreate";
import ProjectFilesList from "./ProjectFilesList";
import ProjectFileUpload from "./ProjectFileUpload";
import ProjectInvoiceList from "./ProjectInvoiceList";
import ProjectClients from "./ProjectClients";
import ProjectBudget from "./ProjectBudget";
import ProjectInvoices from "./ProjectInvoices";

import query from '../../queries/server/project'
import Loading from "./Loading";
import ProjectFeeRates from "./project/ProjectFeeRates";
import ExportFeeProposalButton from "./project/ExportFeeProposalButton";
import {
    checkPermission,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_DETAILS,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_CLIENTS,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_LOCATIONS,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_BUDGETS,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_FEE_RATES,
    PROJECTS_CAN_VIEW_EDIT_PROJECT_NOTES,
    PROJECTS_CAN_VIEW_WRITE_OFFS,
    PROJECTS_CAN_VIEW_INVOICES,
    PROJECTS_CAN_VIEW_SUPPLIER_BUDGETS,
    PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY
} from "../../lib/permissions";
import ProjectWriteoffs from "./project/ProjectWriteoffs";
import ProjectUsers from "./project/ProjectUsers";
import ProjectSupplierInvoices from "./project/ProjectSupplierInvoices";
import ProjectExpenses from "./project/ProjectExpenses";


class Project extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: 'details',
            locations: [
                {
                    location: "176 Ranelagh Road, Ipswich, IP2 0AB"
                }
            ],
            notes: [
                {
                    name: 'Joe Bloggs',
                    note: 'Aenean scelerisque libero non purus tincidunt, in maximus erat tincidunt. Sed ante ipsum, mattis ut metus nec, molestie dictum enim. Aenean mi sem, sodales at tortor nec, varius consequat magna. Maecenas dictum mauris vel nulla egestas lacinia. Proin placerat blandit elit quis rhoncus. Integer ullamcorper scelerisque nisl, id semper lorem accumsan eu. Vivamus in efficitur neque. Mauris eleifend ultricies quam, sit amet viverra metus bibendum nec. Sed vitae lacus pulvinar, consectetur libero sit amet, fermentum massa. Nunc porttitor diam sed semper tincidunt. Phasellus vehicula suscipit nibh vel consequat.',
                    date: '30/04/19 11:38am'
                },
                {
                    name: 'John Smith',
                    note: 'Aliquam vulputate semper risus nec hendrerit. Etiam vitae feugiat odio. Donec porttitor dolor nec tellus sodales laoreet. Donec vehicula dignissim mauris, ut facilisis nulla cursus et. Vivamus vestibulum leo non ex vulputate, quis molestie risus malesuada. Nulla nec turpis a est ullamcorper facilisis eu nec nulla. Integer metus lorem, ultricies ut dolor quis, mollis pulvinar massa.',
                    date: '30/04/19 11:40am'
                }
            ],
            files: [
                {
                    name: 'Fee Proposal.docx',
                    note: 'This is the initial fee proposal',
                    username: 'Joe Bloggs',
                    date: '30/04/19 11:40am'
                }
            ],
            invoices: [
                {
                    invoice_no: '#00122',
                    amount: '14,000',
                    date: '01/03/19',
                    paid: true
                },
                {
                    invoice_no: '#00198',
                    amount: '17,000',
                    date: '01/04/19',
                    paid: false
                }
            ],
            clients: [
                {
                    name: 'Bellway Essex',
                    contacts: [
                        {
                            name: 'Bilbo Baggins',
                            email: 'bb@bellway.co.uk',
                            tel: '01473 222111',
                            mob: '07919 005 788'
                        },
                        {
                            name: 'Joan Jones',
                            email: 'jj@bellway.co.uk',
                            tel: '0207 333 4458',
                            mob: '07919 556 788'
                        }
                    ]
                },
                {
                    name: 'Podpea Ltd',
                    contacts: [
                        {
                            name: 'Paul Cotterell',
                            email: 'paul@podpea.co.uk',
                            tel: '01473 254 067',
                            mob: '07411 239 411'
                        }
                    ]
                }
            ],
            budgets: [
                {
                    activity: 'Structural Engineering',
                    breakdown: [
                        {
                            detail: 'Calculations',
                            amount: '8,500'
                        },
                        {
                            detail: 'Coordinated Revit model & 2D drawings',
                            amount: '9,000'
                        },
                        {
                            detail: 'RC Detailing',
                            amount: '3,600'
                        }
                    ]
                },
                {
                    activity: 'Civils',
                    breakdown: [
                        {
                            detail: 'Drainage',
                            amount: '1,500'
                        },
                        {
                            detail: 'Private landscape areas',
                            amount: '1,500'
                        }
                    ]
                }
            ],
            searchClients: [
                {
                    name: 'Bellway Essex',
                    contacts: [
                        {
                            name: 'Bilbo Baggins',
                            email: 'bb@bellway.co.uk',
                            tel: '01473 222111',
                            mob: '07919 005 788'
                        },
                        {
                            name: 'Joan Jones',
                            email: 'jj@bellway.co.uk',
                            tel: '0207 333 4458',
                            mob: '07919 556 788'
                        }
                    ]
                },
                {
                    name: 'Podpea Ltd',
                    contacts: [
                        {
                            name: 'Paul Cotterell',
                            email: 'paul@podpea.co.uk',
                            tel: '01473 254 067',
                            mob: '07411 239 411'
                        }
                    ]
                }
            ],
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    /*detailChange = (currentProject, value, localMuationFunc) => {
        let newProject = {...currentProject}
        newProject[value.key] = value.value
        localMuationFunc({variables: {data: newProject}})
    }

    addClient = (currentProject, {client_id, name, client_contacts}, localMutationFunc) => {
        let newClients = [
            {
                client: {
                    client_id,
                    name,
                    client_contacts: client_contacts.filter(contact => contact.selected)
                },
                address: {}
            },
            ...currentProject.project_clients
        ]
        this.detailChange(currentProject, {key: 'project_clients', value: newClients}, localMutationFunc)
    }

    removeClient = (currentProject, client, index, localMutationFunc) => {
        let newClients = currentProject.project_clients.filter((c, i) => i !== index)
        this.detailChange(currentProject, {key: 'project_clients', value: newClients}, localMutationFunc)
    }

    budgetAdded = (currentProject, budget, localMutationFunc) => {
        let newBudgets = [{...budget}, ...currentProject.project_activity_budgets]
        this.detailChange(currentProject, {key: 'project_activity_budgets', value: newBudgets}, localMutationFunc)
    }*/

    render() {

        const project_id = this.props.match.params.project_id

        if(!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_DETAILS)) return <Redirect to="/projects"/>

        return (

            <Query query={query} variables={{project_id}}>

                {({data, loading, error, refetch}) => {

                    if (loading) return <Loading/>

                    console.log('PROJECT', data)


                    return (


                        <div className="m-4">

                            <ProjectSummaryBar
                                className="mb-4"
                                project_id={data.project.project_id}
                                clients={data.project.project_clients.map(({client}) => client)}
                                addresses={data.project.project_addresses}
                                total_budget={data.project.total_budget}
                                total_supplier_invoiced={data.project.total_supplier_invoiced}
                                total_fees={data.project.total_fees}
                                budgets={data.project.project_activity_budgets}
                                project={data.project}
                                canViewFinancialSummary={checkPermission(PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY)}
                            />

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'details'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_DETAILS)}
                                        onClick={() => {
                                            this.toggle('details');
                                        }}
                                    >
                                        Details
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'clients'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_CLIENTS)}
                                        onClick={() => {
                                            this.toggle('clients');
                                        }}
                                    >
                                        Clients
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'location'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_LOCATIONS)}
                                        onClick={() => {
                                            this.toggle('location');
                                        }}
                                    >
                                        Location
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'budget'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_BUDGETS)}
                                        onClick={() => {
                                            this.toggle('budget');
                                        }}
                                    >
                                        Budget
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'notes'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_EDIT_PROJECT_NOTES)}
                                        onClick={() => {
                                            this.toggle('notes');
                                        }}
                                    >
                                        Notes
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'invoices'})}
                                        onClick={() => {
                                            this.toggle('invoices');
                                        }}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_INVOICES)}
                                    >
                                        Invoices
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'supplier_invoices'})}
                                        onClick={() => {
                                            this.toggle('supplier_invoices');
                                        }}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_SUPPLIER_BUDGETS)}
                                    >
                                        Suppliers
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'writeoffs'})}
                                        disabled={!checkPermission(PROJECTS_CAN_VIEW_WRITE_OFFS)}
                                        onClick={() => {
                                            this.toggle('writeoffs');
                                        }}
                                    >
                                        Write Offs
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'files'})}
                                        onClick={() => {
                                            this.toggle('files');
                                        }}
                                        disabled={true}
                                    >
                                        Files
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'expenses'})}
                                        onClick={() => {
                                            this.toggle('expenses');
                                        }}
                                    >
                                        Expenses
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'users'})}
                                        onClick={() => {
                                            this.toggle('users');
                                        }}
                                    >
                                        Users
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={this.state.activeTab} style={{paddingBottom: '48px'}}>
                                <TabPane tabId="details">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <ProjectForm
                                                {...data.project}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="clients">
                                    <Row className="mt-4">
                                        <Col>
                                            <ProjectClients
                                                project_id={project_id}
                                                clients={data.project.project_clients.map(({client}) => client)}
                                                searchClients={this.state.searchClients}
                                            />

                                        </Col>

                                    </Row>
                                </TabPane>
                                <TabPane tabId="location" unmountOnExit={true} mountOnEnter={true}>
                                    <Row className="mt-4" style={{height: '885px'}}>
                                        <Col sm="3">
                                            <ProjectLocationsList
                                                project_id={project_id}
                                                locations={data.project.project_addresses}
                                            />
                                        </Col>
                                        <Col>
                                            <ProjectLocation
                                                locations={data.project.project_addresses}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="files">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectFileUpload/>
                                            <ProjectFilesList files={this.state.files}/>
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="notes">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectNoteCreate
                                                project_id={project_id}
                                            />
                                            <ProjectNotesList
                                                project_id={project_id}
                                                notes={data.project.notes}/>

                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="invoices">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectInvoices
                                                project_id={project_id}
                                                project={data.project}
                                                invoices={data.project.invoices}
                                                refetch={refetch}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="supplier_invoices">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectSupplierInvoices
                                                project_id={project_id}
                                                project={data.project}
                                                invoices={data.project.supplier_invoices}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="writeoffs">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectWriteoffs
                                                project={data.project}
                                                project_id={project_id}
                                                writeoffs={data.project.writeoffs}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="budget">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectBudget
                                                project_id={project_id}
                                                addresses={data.project.project_addresses}
                                                budgets={data.project.project_activity_budgets}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="expenses">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectExpenses project={data.project}/>
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="users">
                                    <Row className="mt-4">
                                        <Col sm="12">
                                            <ProjectUsers 
                                                canViewFinances={checkPermission(PROJECTS_CAN_VIEW_FINANCIAL_SUMMARY)} 
                                                data={data.project.users_time_on_project || []}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>

                            <div style={{
                                position: 'fixed',
                                bottom: '0px',
                                backgroundColor: 'lightgray',
                                left: '0px',
                                right: '0px',
                                padding: '10px'
                            }}>

                                <ExportFeeProposalButton project_id={data.project.project_id}/>


                            </div>

                            <ToastContainer/>

                        </div>

                    )

                }}

            </Query>
        );
    }


}

export default Project;
